import React from 'react';
import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../../content/sitePages';

/**
 * Renders a content string with three inline forms, never as HTML:
 *   [text](/path) or [text](#anchor)  → a link (on-site only; anything else stays text)
 *   **text**                          → bold
 *   the support email address         → a mailto link
 */
const TOKEN = new RegExp(
  String.raw`\[([^\]]+)\]\(([^)\s]+)\)|\*\*([^*]+)\*\*|(${SUPPORT_EMAIL.replace(/[.]/g, '\\.')})`,
  'g',
);
const isOnSite = (href) => href.startsWith('#') || (href.startsWith('/') && !href.startsWith('//'));

export default function RichText({ text }) {
  const out = [];
  let last = 0;
  let key = 0;
  for (const m of String(text).matchAll(TOKEN)) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const [whole, linkText, href, bold, email] = m;
    if (linkText !== undefined) {
      if (!isOnSite(href)) out.push(whole);
      else if (href.startsWith('#')) out.push(<a key={key++} href={href} className="text-purple-700 underline underline-offset-2 hover:text-purple-900">{linkText}</a>);
      else out.push(<Link key={key++} to={href} className="text-purple-700 underline underline-offset-2 hover:text-purple-900">{linkText}</Link>);
    } else if (bold !== undefined) {
      out.push(<strong key={key++} className="font-semibold text-gray-900">{bold}</strong>);
    } else if (email !== undefined) {
      out.push(<a key={key++} href={`mailto:${email}`} className="text-purple-700 underline underline-offset-2 hover:text-purple-900">{email}</a>);
    }
    last = m.index + whole.length;
  }
  if (last < text.length) out.push(text.slice(last));
  return <>{out}</>;
}
